/**
 * FT18-U29 (FSD 2.2.8.9, 2.2.8.10): Anomaly Review. Spread into `CLOSE_ROUTES` by
 * `close/routes.ts`, so the router needs no import of its own; nav id `close-anomalies`
 * (s-2.2.8) points here. No module entitlement, like every close route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CLOSE_PERMISSIONS } from '@/modules/close/permissions'

export const CLOSE_ANOMALY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/anomalies',
    name: 'close-anomalies',
    component: () => import('@/modules/close/anomalies/AnomalyReviewView.vue'),
    meta: { titleKey: 'close.anomalyReview.routeTitle', permission: CLOSE_PERMISSIONS.anomalyRead },
  },
]

/** The readiness item `close.anomalies_disposed` — the one this screen clears. */
export const ANOMALY_READINESS_KEY = 'close.anomalies_disposed'

/** Anomaly Review scoped to one legal entity and fiscal period. */
export function anomaliesRoute(scope?: { companyId: number; periodId: number } | null): string {
  if (scope === undefined || scope === null) return '/close/anomalies'
  const params = new URLSearchParams()
  params.set('companyId', String(scope.companyId))
  params.set('periodId', String(scope.periodId))
  return `/close/anomalies?${params.toString()}`
}
